import { render, staticRenderFns } from "./PrimaryAdvisorAvatar.vue?vue&type=template&id=77c72937&"
import script from "./PrimaryAdvisorAvatar.vue?vue&type=script&lang=js&"
export * from "./PrimaryAdvisorAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports